import { useState } from 'react';

import type { FormValues } from './models';
import { Step0 } from './step0';
import Step1 from './step1';
import Step2 from './step2';
import Step3 from './step3';

export const SignupForm = ({
  activeStep,
  setActiveStep,
}: {
  activeStep: number;
  setActiveStep: (step: number) => void;
}) => {
  // Fail closed: a remount mid-flow (e.g. an Unleash poll re-render) resets
  // this state, and a truthy placeholder email would let step 2 POST junk to
  // the CRM. Empty email disables every downstream submit instead.
  const [formData, setFormData] = useState<FormValues>({
    email: '',
  });

  if (activeStep === 1) {
    return <Step1 formData={formData} setActiveStep={setActiveStep} />;
  }

  if (activeStep === 2) {
    return <Step2 setActiveStep={setActiveStep} formData={formData} />;
  }

  if (activeStep === 3) {
    return <Step3 />;
  }

  return <Step0 setActiveStep={setActiveStep} setFormData={setFormData} />;
};
